import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import PageSeo from "../components/PageSeo";
import "./About.css";

const calculators = [
  { title: "EMI Calculator", desc: "Calculate your monthly bike EMI", icon: "💰", path: "/calculator/emi" },
  { title: "Fuel Cost", desc: "Estimate fuel expenses for rides", icon: "⛽", path: "/calculator/fuel" },
  { title: "Trip Planner", desc: "Plan travel time and route spend", icon: "🗺️", path: "/calculator/trip" },
  { title: "Insurance", desc: "Estimate bike insurance premium", icon: "🛡️", path: "/calculator/insurance" },
  { title: "On-Road Price", desc: "Calculate final bike on-road price", icon: "🚦", path: "/calculator/onroad" },
  { title: "Resale Value", desc: "Estimate used bike value", icon: "💸", path: "/calculator/resale" },
  { title: "Maintenance Cost", desc: "Estimate yearly running cost", icon: "🔧", path: "/calculator/maintenance" },
];

export default function Calculator() {
  const navigate = useNavigate();
  const [result, setResult] = useState(""); // State to hold the calculation result
  const [isDarkMode, setIsDarkMode] = useState(false); // State for dark mode

  useEffect(() => {
    const darkModePreference = localStorage.getItem("darkMode") === "true";
    setIsDarkMode(darkModePreference);
    if (darkModePreference) {
      document.body.classList.add("dark");
    } else {
      document.body.classList.remove("dark");
    }
  }, []);

  const toggleDarkMode = () => {
    setIsDarkMode((prevMode) => {
      const newMode = !prevMode;
      localStorage.setItem("darkMode", newMode);
      document.body.classList.toggle("dark", newMode);
      return newMode;
    });
  };

  const shareOnWhatsApp = () => {
    const text = encodeURIComponent(`Check my calculation result: ${result} | MotoHub India https://motohubindia.com`);
    const url = window.innerWidth < 768 
      ? `whatsapp://send?text=${text}` 
      : `https://web.whatsapp.com/send?text=${text}`;
    window.open(url, '_blank');
  };

  const downloadPDF = () => {
    const el = document.getElementById('calculator-result');
    const original = document.title;
    document.title = 'MotoHub-Calculation-Result';
    window.print();
    document.title = original;
  };

  return (
    <>
      <PageSeo
        title="Bike Calculators India | MotoHub India"
        description="Estimate bike EMI, fuel, trip, insurance, resale and maintenance costs."
        path="/calculator"
      />

      <div className="aboutx-root">
        <div className="aboutx-wrap">
          <motion.article className="aboutx-panel" initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}>
            <p className="aboutx-kicker">Calculator Hub</p>
            <h3>Smart bike calculators for Indian riders.</h3>
            <p>Choose any calculator below to plan budget, ownership cost, and ride decisions with confidence.</p>
          </motion.article>
        </div>

        <div className="aboutx-wrap">
          <div className="aboutx-grid">
            {calculators.map((item, index) => (
              <motion.article
                key={item.title}
                className="aboutx-tilt-card"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.05 }}
                onClick={() => navigate(item.path)}
                style={{ cursor: "pointer" }}
              >
                <h3>{item.icon} {item.title}</h3>
                <p>{item.desc}</p>
                <button style={openBtn}>Open</button>
              </motion.article>
            ))}
          </div>
        </div>
      </div>
      <div id="calculator-result">
        {result && (
          <>
            <button onClick={shareOnWhatsApp} 
              className="bg-green-500 hover:bg-green-600 text-white px-4 py-2 rounded-lg text-sm">
              Share on WhatsApp
            </button>
            <button onClick={downloadPDF}
              className="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded-lg text-sm">
              Download PDF
            </button>
          </>
        )}
      </div>
    </>
  );
}

const openBtn = {
  marginTop: "14px",
  padding: "10px 14px",
  borderRadius: "10px",
  border: "none",
  color: "#fff",
  fontWeight: 700,
  cursor: "pointer",
  background: "linear-gradient(120deg, #f59e0b, #ea580c)",
};
